import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import UsageManualDocumentMeta from './UsageManualDocumentMeta';
import UsageManualPdfViewer from './UsageManualPdfViewer';
import { getDocumentForLanguage } from '../constants';
const UsageManualReaderView = ({ manual }) => {
    const { i18n } = useTranslation();
    const document = useMemo(() => {
        const appLang = i18n.language?.split('-')[0]?.toLowerCase() ?? 'en';
        return getDocumentForLanguage(manual, appLang) ?? manual.documents[0];
    }, [manual, i18n.language]);
    if (!document)
        return null;
    return (_jsxs(Box, { sx: { display: 'flex', flexDirection: 'column', gap: 2 }, children: [_jsx(UsageManualDocumentMeta, { manual: manual, document: document }), _jsx(UsageManualPdfViewer, { documentUrl: document.documentUrl, title: document.documentName, height: 'calc(100dvh - 320px)' })] }));
};
export default UsageManualReaderView;
